import { fetchOAuthToken } from './oauthService'

export const getToken = async (): Promise<string> => {
  const token = await fetchOAuthToken()
  console.log('[TokenService] Created new public token')
  return token
}
